type AnalyticsEventParams = {
    eventName: string;
};

export class AnalyticsEventHandler {
    public handle(__params: AnalyticsEventParams): void {
        /* TODO выпилить (с клиента тоже), когда будем уверены, что выпиливание GA/YM работает */
    }
}
